import { z } from "zod";
import { Type, type Static } from "@sinclair/typebox";
import { BrowserFrontendToolRequestSchema, BrowserToolRpcResultSchema } from "./browser-expert.ts";

export const UserAutomationBrowserProofSchema = z
  .object({
    payload: z.string().min(1).max(700_000),
    signature: z.string().regex(/^[A-Za-z0-9_-]{86}$/u),
    publicKey: z.string().min(1).max(512)
  })
  .strict();
export type UserAutomationBrowserProof = z.infer<typeof UserAutomationBrowserProofSchema>;

const scope = {
  version: z.literal("1.0"),
  roomId: z
    .string()
    .max(512)
    .regex(/^!\S+$/u),
  sourceEventId: z
    .string()
    .max(512)
    .regex(/^\$\S+$/u),
  automationId: z.uuid(),
  revision: z.number().int().positive(),
  ownerPrincipalId: z.uuid(),
  ownerMxid: z
    .string()
    .max(512)
    .regex(/^@\S+:\S+$/u),
  deviceId: z.uuid(),
  executorId: z.uuid(),
  issuedAt: z.number().int().positive(),
  expiresAt: z.number().int().positive(),
  deadlineAt: z.number().int().positive()
};
export const UserAutomationBrowserCommandSchema = z.discriminatedUnion("operation", [
  z.object({ ...scope, operation: z.literal("probe") }).strict(),
  z
    .object({
      ...scope,
      operation: z.literal("request"),
      requestId: z.uuid(),
      request: BrowserFrontendToolRequestSchema
    })
    .strict(),
  z.object({ ...scope, operation: z.literal("close") }).strict()
]);
export type UserAutomationBrowserCommand = z.infer<typeof UserAutomationBrowserCommandSchema>;

export const UserAutomationBrowserReplySchema = z
  .object({
    version: z.literal("1.0"),
    commandDigest: z.string().regex(/^[a-f0-9]{64}$/u),
    deviceId: z.uuid(),
    executorId: z.uuid(),
    expiresAt: z.number().int().positive(),
    result: BrowserToolRpcResultSchema
  })
  .strict();
export type UserAutomationBrowserReply = z.infer<typeof UserAutomationBrowserReplySchema>;

export const UserAutomationBrowserContextSchema = Type.Object(
  {
    principalId: Type.String({ format: "uuid" }),
    publicKey: Type.String({ minLength: 1, maxLength: 512 })
  },
  { additionalProperties: false }
);
export type UserAutomationBrowserContext = Static<typeof UserAutomationBrowserContextSchema>;
